import { c as _c } from "react/compiler-runtime";
import { FunnelStepActions } from 'modules/funnels/funnel/components/funnel-step-page-actions/funnel-step-actions';
import { useBaseFunnelStepConfigurationSettings } from 'modules/funnels/funnel/hooks/use-base-funnel-step-configuration-settings';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import type { FunnelStepPageActionsProps } from 'modules/funnels/funnel/types/funnel-step-page-actions-props';
import { getFunnelStepPreviewUrl, getStepPreviewUrl } from 'modules/funnels/funnel/utils/page-utils';
interface BaseFunnelStepActionsProps extends FunnelStepPageActionsProps {
  showPreview?: boolean;
}
function BaseFunnelStepActions(t0) {
  const $ = _c(12);
  const {
    funnelId,
    funnelStep,
    pageId,
    showPreview
  } = t0;
  const {
    funnel
  } = useFunnel(funnelId);
  const {
    funnelStepConfigurationSettings
  } = useBaseFunnelStepConfigurationSettings(funnelStep.id);
  let t1;
  if ($[0] !== funnel || $[1] !== funnelStep.inRunningSplitTest || $[2] !== funnelStepConfigurationSettings || $[3] !== showPreview) {
    t1 = () => {
      if (!funnel || !funnelStepConfigurationSettings) {
        return;
      }
      const {
        domainName
      } = funnel.domain;
      const {
        path
      } = funnelStepConfigurationSettings.page;
      return showPreview ? getFunnelStepPreviewUrl(domainName, path) : getStepPreviewUrl(domainName, path, funnelStep.inRunningSplitTest);
    };
    $[0] = funnel;
    $[1] = funnelStep.inRunningSplitTest;
    $[2] = funnelStepConfigurationSettings;
    $[3] = showPreview;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getViewLinkUrl = t1;
  const t2 = funnelStep.id;
  let t3;
  if ($[5] !== getViewLinkUrl) {
    t3 = getViewLinkUrl();
    $[5] = getViewLinkUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== funnelId || $[8] !== funnelStep.id || $[9] !== pageId || $[10] !== t3) {
    t4 = <FunnelStepActions funnelId={funnelId} funnelStepId={t2} pageId={pageId} viewLinkUrl={t3} />;
    $[7] = funnelId;
    $[8] = funnelStep.id;
    $[9] = pageId;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export { BaseFunnelStepActions };